'use strict';

var App = require('app');
var AppState = require('app_state');
var Consts = require('consts');
var DataEditDialogView = require('components/devices/views/common/data_edit_dialog_view');
var EditAF1Template = require('components/scheme/templates/edit_af1_dialog');
var EditPumpTemplate = require('components/scheme/templates/edit_pump_dialog');
var EditValveTemplate = require('components/scheme/templates/edit_valve_dialog');
var Event = require('utils/event');
var GetElementIdentifier = require('components/scheme/display_functions').GetElementIdentifier;
var i18n = require('utils/i18n');
var Log = require('utils/log');
var ManualModeSymbol = require('components/scheme/templates/manual_mode_symbol');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var RegisterFunctions = require('components/scheme/display_functions').RegisterFunctions;
var SchemaFunctions = require('components/scheme/display_functions').SchemaFunctions;
var StringUtils = require('utils/strings');
var SVG = require('utils/svg');
var Values = require('models/values');
var ValueSvgTemplate = require('components/scheme/templates/value_svg');

var SchemaView = Marionette.ItemView.extend({
    template: require('components/scheme/templates/main'),

    controller: undefined,

    ui: {
        container: '#schema-container',
        info: '#info-container',
        controls: '#schema-controls',
        schema: '#schema-svg',
        minimap: '#js-minimap-container',
    },

    events: {
        'click #UP1, #UP2, #UP3, #UP4, #UP5, #ZP, #SLP, #CP': 'clickedPump',
        'click #RK1, #RK2, #RK3': 'clickedValve',
        'click #g-AF1': 'clickedAF1',

        'touchend #UP1, #UP2, #UP3, #UP4, #UP5, #ZP, #SLP, #CP': 'clickedPump',
        'touchend #RK1, #RK2 , #RK3': 'clickedValve',
        'touchend #g-AF1': 'clickedAF1',

        'wheel svg, #js-minimap-container': 'navigate',
        'mousemove svg, #js-minimap-container': 'navigate',
        'mousedown svg, #js-minimap-container': 'navigate',
        'mouseup svg, #js-minimap-container': 'navigate',
        'touchstart svg, #js-minimap-container': 'navigate',
        'touchmove svg, #js-minimap-container': 'navigate',
        'touchend svg, #js-minimap-container': 'navigate',
    },

    dummySchema: {
        attributes: {
            registers: [],
            coils: [],
        },

        fetch: function (params) {
            params.success();
        },
    },

    initialize: function (options) {
        this.editMode = false;
        this.schema = options.schema || this.dummySchema;
        this.controller = options.controller;
        this.sensorValues = options.sensorValues || [];
        this.initDataPoints();
        this.columns = this.options.columns;
        this.unfetched = false;
        this.valueMap = options.valueMap;
        this.valueConfig = options.valueConfig;
        this.circuitNr = options.circuitNr;
        this.commonValues = options.commonValues;
        this.readOnly = options.readOnly;
        this.registerMap = {};
        this.nonPollingValues = {};
        this.svgFuncList = [];
        this.inconsistent = [];

        this.viewBoxIsAltered = false;

        if (options.inconsistent) {
            this.inconsistent = options.inconsistent.data_points || [];
        }
        this.checkConsistency = options.inconsistent !== undefined;

        this.isLegendShown = false;
        this.isAutoRefresh = options.isAutoRefresh || false;
        this.isShowActualValue = true;
        this.valuesInitialized = false;

        // svg-parameter initialisation
        this.viewState = {
            zoom: 1, // zoom level
            centerX: 0.5, // relative position of the horizontal scrollbar (0=left, 1=right)
            centerY: 0.5, // relative position of the vertical scrollbar (0=top, 1=bottom)
            width: 800, // width of the div containing the schema
            height: 500, // height of the div containing the schema
            distance: -1, // distance between first and second finger
            wasMoved: false,
            pointerPositionX: -1, // mouse/finger horizontal-position
            pointerPositionY: -1, // mouse/finger vertical-position
        };

        var self = this;
        this.schemaContext = {
            device: this.model,
            isShowActualValue: function () {
                return self.isShowActualValue;
            },
            isEditMode: this.options.isEditMode,
        };
        $(window).on('mouseup', $.proxy(this.updateMinimap, this));
    },

    onShow: function () {
        $('button').tooltip({
            html: true,
            container: 'body',
            trigger: 'hover',
        });

        // test browsersupport for scrolling (edge...)
        try {
            this.ui.container[0].scrollBy(0, 0);
        } catch (err) {
            // browser does not support scrolling by javascript? -> no minimap
            this.viewState.noScroll = true;
        }
    },

    setPermission: function (permissions) {
        this.readOnly = permissions.get(Consts.Permissions.StateSchema) || this.model.isWritingDisabled();
    },

    initDataPoints: function () {
        var dataPoints = this.schema.attributes;
        this.registers = $.extend(true, {}, dataPoints.registers);
        this.coils = $.extend(true, {}, dataPoints.coils);
        this.circuitNr = this.options.circuitNr;

        if (this.circuitNr > 100) {
            // remove coils and register specific to circuit 1
            this.registers = _.omit(this.registers, _.values(Consts.TrovisIORegister));
            this.coils = _.omit(this.coils, _.values(Consts.TrovisIOCoils));

            // insert Trovis I/O-specific values as values from circuit 1
            _.each(
                this.registers,
                function (value, key) {
                    if (key.includes(this.circuitNr / 10) && Consts.TrovisIORegister.hasOwnProperty(key)) {
                        this.registers[Consts.TrovisIORegister[key]] = value;
                    }
                },
                this
            );

            _.each(
                this.coils,
                function (value, key) {
                    if (key.includes(this.circuitNr / 10) && Consts.TrovisIOCoils.hasOwnProperty(key)) {
                        this.coils[Consts.TrovisIOCoils[key]] = value;
                    }
                },
                this
            );
        }
    },

    hideFeeler: function (feelerID) {
        $('[id^="' + feelerID + '"]').attr('display', 'none');
        if (feelerID == 'AF1') {
            $('#Außenwand').attr('display', 'none');
        }
    },

    addSVGElement: function (attributes) {
        var autoElementLayer = document.getElementById('auto-elements');
        if (autoElementLayer === null) {
            autoElementLayer = SVG.createSVGElement('g', { id: 'auto-elements' });
            var svgContainer = document.getElementById('schema-svg');

            // any custom elements in the svg?
            var customElements = document.getElementsByClassName('SDECustom');
            if (customElements === undefined) {
                svgContainer.append(autoElementLayer);
            } else {
                // insert before first custom element
                svgContainer.insertBefore(autoElementLayer, customElements[0]);
            }
        }
        $(autoElementLayer).append(ValueSvgTemplate(attributes));
    },

    showFeelerValueBox: function (feelerID) {
        var $sensorLines = $('#' + feelerID + '_x5F_Sensor > line');
        if ($sensorLines.length == 0) {
            Log.warning('Could not find element for feeler ' + feelerID);
            return;
        }

        function value(element, key) {
            if (element.length != 1) {
                Log.warning('Could not find element for feeler ' + feelerID);
                return;
            }
            return element[0][key].baseVal.value;
        }

        var minX = 999999;
        var minY = 999999;

        $sensorLines.each(function () {
            var x1 = value($(this), 'x1');
            var x2 = value($(this), 'x2');
            var y1 = value($(this), 'y1');
            var y2 = value($(this), 'y2');

            minX = _.min([minX, x1, x2]);
            minY = _.min([minY, y1, y2]);
        });

        this.addSVGElement({
            type: 'feeler',
            width: 24,
            deltaX: 12,
            id: feelerID,
            minX: minX,
            minY: minY,
        });
    },

    showValveValueBox: function (valveID) {
        var $valve = $('#' + valveID);
        if ($valve.length != 1) {
            Log.warning('Could not find element for valve ' + valveID);
            return;
        }

        var valveBB = $valve[0].getBBox();

        var minX = valveBB.x + valveBB.width / 2 - 9;
        var minY = valveBB.y + valveBB.height + 3;

        this.addSVGElement({
            type: 'valve',
            width: 18,
            deltaX: 9,
            id: valveID,
            minX: minX,
            minY: minY,
        });
    },

    hideLegend: function () {
        $('#legend').attr('display', 'none');

        $('#_x35_573').attr('display', 'none');
        $('#_x35_575').attr('display', 'none');
        $('#_x35_576').attr('display', 'none');
        $('#_x35_578').attr('display', 'none');
        $('#_x35_579').attr('display', 'none');

        $('#_x35_573-1').attr('display', 'none');
        $('#_x35_573_1_').attr('display', 'none');
    },

    showLegend: function () {
        $('#legend').removeAttr('display');

        var legendID = this.model.get('type').substring(1);
        $('#_x35_' + legendID).removeAttr('display');
        $('#_x35_' + legendID + '-1').removeAttr('display');
        $('#_x35_' + legendID + '_1_').removeAttr('display');
    },

    refreshSchema: function (_, refetchValues) {
        if (this.isDestroyed) {
            return;
        }

        // must consider consistency?
        var inconsistent = null;
        if (this.checkConsistency) {
            inconsistent = App.request('device:inconsistent', this.model);
        }

        var self = this;
        var getInconsistencies = function (model) {
            if (model) {
                self.triggerMethod('fetched:schema', $.extend({}, model.attributes.coils, model.attributes.registers));
            }
            $.when(inconsistent).done(function (inconsistent) {
                self.initDataPoints();
                self.inconsistent = inconsistent.data_points || [];

                if (!self.isDestroyed) {
                    self.updateSchema(refetchValues);
                }
            });
        };

        this.schema.fetch({ success: getInconsistencies });
    },

    // first parameter is an event, which is not needed here
    setAutoRefresh: function (_, isAutoRefresh) {
        this.isAutoRefresh = isAutoRefresh;
        if (this.isAutoRefresh) {
            this.updateSchema();
            this.initializeTimer();
        }
    },

    toggleLegend: function () {
        this.isLegendShown = !this.isLegendShown;

        // update legend display state
        if (this.isLegendShown) {
            this.showLegend();
        } else {
            this.hideLegend();
        }

        this.updateViewBox();
    },

    getValue: function (reg, digits, unit) {
        unit = unit === undefined ? '' : ' ' + unit;
        if (reg in this.registers && this.registers[reg] != 32767) {
            return StringUtils.fixedPoint(this.registers[reg], digits, true) + unit;
        }
        return '--';
    },

    getPumpState: function (pump) {
        var trovisIOPumpMap = {
            110: 'UP11',
            120: 'UP12',
            130: 'UP13',
        };

        if (pump === 'UP1') {
            pump = trovisIOPumpMap[this.circuitNr] || pump;
        }

        if (this.coils[pump + '_e']) {
            return 'auto';
        }
        return this.coils[pump] ? 'on' : 'off';
    },

    updateSchema: function (refetchValues) {
        var self = this;

        // show device state hints
        Misc.setVisible('#js-inconsistency-hint', this.inconsistent.length > 0);
        Misc.setVisible('#js-lock-hint', AppState.deviceIsLockedForUser(this.model.id));
        Misc.setVisible('#js-unfetched-hint', this.unfetched);
        Misc.setVisible('#js-loading-values-hint', !this.valuesInitialized);

        function showManualModeSymbol($container, position, anchor) {
            if (!$container[0]) {
                return;
            }
            var pos = SVG.positionElement($container[0].getBBox(), { width: 6.3, height: 4.9 }, position, anchor);
            $container.append(ManualModeSymbol({ x: pos.x, y: pos.y }));
        }

        // remove all previous highlights
        $('.js-manual-mode').remove();

        // update feeler values
        _.each(Consts.Feelers, function (f) {
            var valueReg = f + (self.isShowActualValue ? '' : '_s');
            $('#feeler-' + f).text(self.getValue(valueReg, 1, '°C'));
            $('#g-' + f).attr('display', valueReg in self.registers || self.isShowActualValue ? 'visible' : 'none');
            $('#box-feeler-' + f).attr(
                'class',
                'value-box ' + (self.isConsistent(f) ? 'feeler-value' : 'inconsistent-value')
            );

            // manual mode? -> highlight
            if (self.coils[f + '_e'] === false) {
                showManualModeSymbol($('#g-' + f), 'r', 'l');
            }
        });

        // update valve values
        _.each(Consts.Valves, function (v) {
            var valueReg = v + (self.isShowActualValue ? '' : '_s');
            $('#valve-' + v).text(self.getValue(valueReg, 0, '%'));
            $('#g-' + v).attr('display', valueReg in self.registers || self.isShowActualValue ? 'visible' : 'none');
            $('#box-valve-' + v).attr(
                'class',
                'value-box ' + (self.isConsistent(v) ? 'valve-value' : 'inconsistent-value')
            );
        });

        // update pump and flow states
        _.each(Consts.Pumps, function (p) {
            var cold = $('#BLAU_x5F_' + p);
            var hot = $('#ROT_x5F_' + p);
            var pump = $('#' + p);

            var pumpState = 'pump-off';

            $('#cold-background-' + p).remove();
            cold.removeAttr('class');

            $('#hot-background-' + p).remove();
            hot.removeAttr('class');

            if (p in self.coils && self.coils[p]) {
                pumpState = 'pump-active';

                cold.each(function (pos, element) {
                    var clone = element.cloneNode(true);
                    $(clone).attr('class', 'flow-cold-background');
                    $(clone).attr('id', 'cold-background-' + p);
                    $(this).before(clone);
                });
                cold.attr('class', 'flow-cold');

                hot.each(function (pos, element) {
                    var clone = element.cloneNode(true);
                    $(clone).attr('class', 'flow-hot-background');
                    $(clone).attr('id', 'hot-background-' + p);
                    $(this).before(clone);
                });
                hot.attr('class', 'flow-hot');
            }

            // manual mode? -> highlight
            if (self.getPumpState(p) != 'auto') {
                showManualModeSymbol(pump);
            }

            pump.attr('class', self.isConsistent(p) ? pumpState : 'inconsistent');
        });

        // update valve and flow state
        _.each(Consts.Valves, function (v) {
            var cold = $('#BLAU_x5F_' + v);
            var hot = $('#ROT_x5F_' + v);
            var valve = $('#' + v);

            var valveState = 'pump-off';

            $('#cold-background-' + v).remove();
            cold.removeAttr('class');

            $('#hot-background-' + v).remove();
            hot.removeAttr('class');

            if (v in self.registers && self.registers[v] > 0) {
                valveState = 'pump-active';

                cold.each(function (pos, element) {
                    var clone = element.cloneNode(true);
                    $(clone).attr('class', 'flow-cold-background');
                    $(clone).attr('id', 'cold-background-' + v);
                    $(this).before(clone);
                });
                cold.attr('class', 'flow-cold');

                hot.each(function (pos, element) {
                    var clone = element.cloneNode(true);
                    $(clone).attr('class', 'flow-hot-background');
                    $(clone).attr('id', 'hot-background-' + v);
                    $(this).before(clone);
                });
                hot.attr('class', 'flow-hot');
            }
            valve.attr('class', self.isConsistent(v) ? valveState : 'inconsistent');

            // manual mode? -> highlight
            if (self.coils[v + '_e'] === false) {
                showManualModeSymbol(valve);
            }
        });

        this.evaluateSchemaFunctions(refetchValues);
        this.triggerMethod('scheme:ready');
    },

    updateViewBox: function () {
        this.ui.schema[0].setAttribute('viewBox', this.isLegendShown ? this.vbWithLegend : this.vbWithoutLegend);
    },

    initializeViewBox: function () {
        // TODO: check existing controller schemas -> ViewBox adaptation might not be required
        var viewBox = $('svg')[0].viewBox.baseVal;

        // assumption: the legend is hidden!

        // .. extend the box to let room for value display
        if (!this.viewBoxIsAltered) {
            viewBox.width = viewBox.width + 20;
            this.viewBoxIsAltered = true;
        }

        // .. determine the bounding box of all currenty visible groups
        var maxVisibleY = 0;
        $('svg > g').each(function (i, g) {
            if (g.getAttribute('display') !== 'none') {
                var bb = g.getBBox();
                maxVisibleY = Math.max(maxVisibleY, bb.y + bb.height);
            }
        });
        this.vbWithLegend = viewBox.x + ' ' + viewBox.y + ' ' + viewBox.width + ' ' + viewBox.height;
        this.vbWithoutLegend = viewBox.x + ' ' + viewBox.y + ' ' + viewBox.width + ' ' + (maxVisibleY + 10);

        this.updateViewBox();
    },

    initializeTimer: function (delay) {
        if (!this.isAutoRefresh) {
            return;
        }

        // default timeout
        delay = delay || 1000;

        var self = this;
        // timout too large -> turn off auto refresh
        if (delay > 5000) {
            Notification.show('error', i18n.TR('Fehler'), i18n.TR('Anlagenschema konnte nicht aktualisiert werden.'));
            self.isAutoRefresh = false;
            self.triggerMethod('disable:auto:refresh');
            return;
        }

        setTimeout(function () {
            // must consider consistency?
            var inconsistent = null;
            if (self.checkConsistency) {
                inconsistent = App.request('device:inconsistent', self.model);
            }

            self.schema.fetch({
                success: function (model) {
                    if (model) {
                        self.triggerMethod(
                            'fetched:schema',
                            $.extend({}, model.attributes.coils, model.attributes.registers)
                        );
                    }
                    $.when(inconsistent).done(function (inconsistent) {
                        self.registers = self.schema.attributes.registers || [];
                        self.coils = self.schema.attributes.coils || [];
                        self.inconsistent = inconsistent.data_points || [];

                        if (!self.isDestroyed) {
                            self.initDataPoints();
                            self.updateSchema();
                            self.initializeTimer();
                        }
                    });
                },
                error: function () {
                    if (!self.isDestroyed) {
                        // error -> increase timeout
                        self.initializeTimer(delay * 2);
                    }
                },
            });
        }, delay);
    },

    showSettingsDialog: function (options) {
        if (!this.readOnly) {
            this.controller.showSchemaSettingsDialog(options);
        }
    },

    setCircuitNames: function () {
        _.each(this.model.getCircuitNames(), function (v, k) {
            var $circuitNameElement = $('#name-' + k);
            $circuitNameElement.text(v);
        });
    },

    valueSaveCB: function (newValue, newSchema) {
        Notification.show('success', i18n.TR('Erfolg'), i18n.TR('Einstellungen gespeichert.'));
        App.hideModal();
        // this.schema contains values for all circuits. Override values of the current circuit
        this.schema.attributes.registers = $.extend(this.schema.attributes.registers, newSchema.registers);
        this.schema.attributes.coils = $.extend(this.schema.attributes.coils, newSchema.coils);

        this.initDataPoints();
        this.updateSchema();
    },

    isConsistent: function (element) {
        var valueID = Consts.SchemaElementsToDataPoint[element] || ''; // value
        var valueID_e = Consts.SchemaElementsToDataPoint[element + '_e'] || ''; // value 'Ebenenbit'

        return !_.contains(this.inconsistent, valueID) && !_.contains(this.inconsistent, valueID_e);
    },

    checkInconsistency: function (element) {
        var isConsistent = this.isConsistent(element);
        if (!isConsistent) {
            Notification.show(
                'warning',
                i18n.TR('Warnung'),
                i18n.TR('Vorangegangener Schreibbefehl wird verarbeitet.')
            );
            this.refreshSchema();
        }

        return isConsistent;
    },

    clickedPump: function (e) {
        if (this.readOnly) {
            return;
        }
        e.stopPropagation();
        var label = e.currentTarget.id;

        if (!this.checkInconsistency(label) || !this.isClickEvent(e)) {
            return;
        }

        var self = this;
        this.showSettingsDialog({
            deviceID: this.model.id,
            template: EditPumpTemplate,
            label: label,
            state: this.getPumpState(label),
            circuitNr: this.circuitNr,
            save_cb: function (value, schema) {
                self.valueSaveCB(value, schema);
            },
        });
    },

    clickedValve: function (e) {
        if (this.readOnly) {
            return;
        }
        e.stopPropagation();
        var label = e.currentTarget.id;

        if (!this.checkInconsistency(label) || !this.isClickEvent(e)) {
            return;
        }

        var self = this;
        this.showSettingsDialog({
            deviceID: this.model.id,
            template: EditValveTemplate,
            label: label,
            // values are displayed as "value-1" (see formatter), so we have to add "+1" here
            value: this.coils[label + '_e'] ? 0 : parseInt(this.getValue(label, 0)) + 1,
            circuitNr: this.circuitNr,
            slider: {
                tooltip: 'always',
                ticks: [0, 101],
                ticks_labels: ['<strong>Auto</strong>', '100 %'],
                formatter: function (value) {
                    return value == 0 ? 'Auto' : value - 1 + ' %';
                },
            },
            save_cb: function (newValue, newSchema) {
                self.valueSaveCB(newValue, newSchema);
            },
        });
    },

    clickedAF1: function (e) {
        if (this.readOnly) {
            return;
        }
        e.stopPropagation();

        if (!this.checkInconsistency('AF1')) {
            return;
        }
        var self = this;
        var value = 0;
        // inactive outdoorsensor or got an valid value? -> use value
        if (!this.coils['AF1_e'] && this.registers['AF1'] && this.registers['AF1'] !== 32767) {
            // values are displayed as "value-1" (see formatter), so we have to add "+1" here
            value = (Misc.getSignedInt(this.registers['AF1']) / 10) * 2 + 80 + 1;
        }
        this.showSettingsDialog({
            deviceID: this.model.id,
            template: EditAF1Template,
            label: 'AF1',
            value: value,
            circuitNr: this.circuitNr,
            slider: {
                tooltip: 'always',
                ticks: [0, 81, 401],
                ticks_positions: [0, 40, 100], // %
                ticks_labels: ['<strong>Auto</strong>', '0 °C', '160 °C'],
                formatter: function (value) {
                    return value == 0 ? 'Auto' : (value * 0.5 - 40.5).toFixed(1) + ' °C';
                },
            },
            save_cb: function (value, schema) {
                self.valueSaveCB(value, schema);
            },
        });
    },

    writeValue: function (e) {
        var self = e.data.view;
        if (self.options.readOnly || self.options.isEditMode) {
            return;
        }
        if (e.data.edit === '') {
            Log.schema('no app-edit value supplied');
            return;
        }

        // has the svg specified, which value (if any) should be edited?
        var value;
        try {
            var v = typeof e.data.edit === 'object' ? e.data.edit : JSON.parse(e.data.edit);
            value = self.isShowActualValue ? v.actualValue : v.desiredValue;
            if (value === undefined) {
                return;
            }
        } catch (error) {
            // not a json? -> use raw string as it is.
            value = e.data.edit;
        }

        var params = value.split('@');
        // no device specified? -> use current device
        if (params.length === 1) {
            params.push(e.data.view.model.id);
        }

        var reg = params[0];
        var deviceID = params[1];
        var typeNr = reg.split('_');
        if (typeNr.length != 2) {
            Log.schema('bad syntax for value.');
            return;
        }

        var valueCfg = _.filter(e.data.view.valueConfig[deviceID], { type: typeNr[0], nr: parseInt(typeNr[1]) })[0];

        if (!valueCfg) {
            Log.schema('value not found');
            return;
        }
        if (valueCfg.is_readonly) {
            Log.schema('value is read only');
            return;
        }

        valueCfg['data'] = {};
        valueCfg['data'][reg] = e.data.view.valueMap[deviceID][reg];
        valueCfg['device'] = deviceID;

        App.showModal(
            new DataEditDialogView.Dialog({
                model: new Values.Model(valueCfg),
                device: { id: deviceID },
                controller: e.data.view.controller,
                callback: $.proxy(e.data.view.fetchCustomValuesAndEvaluateSchemaFunctions, e.data.view),
            })
        );
    },

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);
        data.readOnly = this.readOnly;
        data.editMode = this.editMode;
        return data;
    },

    // valueConfigurationNeedsUpdate returns true, if there is a data point without format/configuration
    valueConfigurationNeedsUpdate: function () {
        var haveRegisters = this.registerMap != undefined && !$.isEmptyObject(this.registerMap);
        var noConfiguration = this.valueConfig === undefined || $.isEmptyObject(this.valueConfig);

        if (haveRegisters && noConfiguration) {
            return true;
        }

        function containsDataPoint(dataPoint, deviceID, valueConfiguration) {
            return _.reduce(
                valueConfiguration[deviceID],
                function (memo, config) {
                    return dataPoint === config.type + '_' + config.nr || memo;
                },
                false
            );
        }

        var needUpdate = false;
        // Iterate over each device in registerMap
        _.each(
            this.registerMap,
            function (dataPoints, deviceID) {
                // For each dataPoint of a device, check if it is in valueConfig
                _.each(
                    dataPoints,
                    function (dp) {
                        needUpdate = needUpdate || !containsDataPoint(dp, deviceID, this.valueConfig);
                    },
                    this
                );
            },
            this
        );

        return needUpdate;
    },

    loadSchema: function (svg) {
        var schemaObject = this.ui.schema;

        svg = svg || this.options.svg;

        schemaObject.replaceWith(svg);

        // fix font (user 'Arial' instead of 'ArialMT')
        $('svg text').attr('font-family', 'Arial');

        // always use bounding-box as click area for paths
        $('g > circle').attr('pointer-events', 'bounding-box');
        $('g > path').attr('pointer-events', 'bounding-box');
        $('g > polygon').attr('pointer-events', 'bounding-box');
        $('g > polyline').attr('pointer-events', 'bounding-box');

        // initialize feeler value elements
        _.each(
            Consts.Feelers,
            function (f) {
                if (f in this.registers) {
                    // feeler available -> insert value box
                    this.showFeelerValueBox(f);
                } else {
                    // hide feeler elements
                    this.hideFeeler(f);
                }
            },
            this
        );

        // initialize valve value elements
        _.each(
            Consts.Valves,
            function (v) {
                if (v in this.registers) {
                    this.showValveValueBox(v);
                }
            },
            this
        );

        // see http://stackoverflow.com/a/13654655
        $('#schema-container').html($('#schema-container').html());
        var self = this;
        this.initializeSchemaFunctions(this.registerMap);
        if (this.valueConfigurationNeedsUpdate()) {
            this.controller.getUploadConfiguration(
                $.extend(true, {}, this.registerMap, this.nonPollingValues),
                function (valueConfig) {
                    self.valueConfig = valueConfig;
                    self.triggerMethod('fetched:config', valueConfig);
                    self.updateSchema();
                }
            );
        } else {
            this.updateSchema();
        }

        this.delegateEvents();

        this.hideLegend();
        this.setCircuitNames();
        this.initializeViewBox();
        this.initializeTimer();
    },

    handleToolbarEvent: function (e, params) {
        var buttonID = e.currentTarget.id;
        var idToFunction = {
            'js-refresh': this.refreshSchema,
            'js-toggle-legend': this.toggleLegend,
            'js-show-actual-values': this.showActualValues,
            'js-show-set-point-values': this.showSetPointValues,
            'js-zoom-reset': this.setZoom,
            'js-zoom-in': this.setZoom,
            'js-zoom-out': this.setZoom,
            'js-toggle-auto-refresh': this.setAutoRefresh,
        };
        idToFunction[buttonID].call(this, e, params);
    },

    onAttach: function () {
        this.loadSchema();
        var self = this;

        // initialize resize handler
        window.svgSchemaResizeHandler = function () {
            var h = window.innerHeight - (AppState.isFullScreen ? 60 : 345); // trial and error
            self.ui.container.css('height', h + 'px');
            self.ui.info.css('height', h + 42 + 'px');
            // @ui.element is not available after resize, therefore we need jquery
            self.viewState.width = $('#schema-svg').width() / self.viewState.zoom;
            self.viewState.height = $('#schema-svg').height() / self.viewState.zoom;
            if (self.controller.resizeCallback) {
                self.controller.resizeCallback();
            }
        };
        window.resizefunc.push('svgSchemaResizeHandler');

        // initialize container
        window.svgSchemaResizeHandler();
    },

    onBeforeDestroy: function () {
        // remove resize handler
        var handlerFuncIndex = window.resizefunc.indexOf('svgSchemaResizeHandler');
        if (handlerFuncIndex != -1) {
            window.resizefunc.splice(handlerFuncIndex, 1);
            window.svgSchemaResizeHandler = undefined;
        }
        $(window).off('mouseup', $.proxy(this.updateMinimap, this));
    },

    // scans the schema for all custom functions and all needed Parameters
    initializeSchemaFunctions: function () {
        var self = this;

        // returns a function constructed from the "app-func"-attribute in the svg
        function functionFactory(name, parameter, context, definedParameterList, isLegacyFunction) {
            // - name:      function name as defined in the svg
            // - parameter: contains the svg element and the register/coils requested by the function
            // - context:   the context given in the svg
            if (name.endsWith('_disabled')) {
                return undefined;
            }

            return function (responseValues, uploadConfig, cachedDeviceData) {
                // merge cachedDeviceData into responseValues
                responseValues[self.model.id] = $.extend({}, true, cachedDeviceData, responseValues[self.model.id]);
                var values = [];
                // pick required function parameters from the device response or the frontend-cached values
                _.each(parameter.valueReferences, function (valRef) {
                    // device response contains none of our requested values? -> do not evaluate the function
                    var deviceID = valRef.deviceID;
                    if (responseValues[deviceID] === undefined || $.isEmptyObject(responseValues[deviceID])) {
                        console.log(
                            'no device values for function: "' +
                                name +
                                '" and element: "' +
                                GetElementIdentifier(parameter.element) +
                                '".'
                        );
                        return;
                    }

                    var register = valRef.registerList[0];
                    var value = {
                        has_format: false,
                        nr: parseInt(register.split('_')[1]),
                        type: register.split('_')[0],
                        deviceID: deviceID,
                    };

                    if (valRef.registerList.length > 1) {
                        if (typeof context === 'string') {
                            context = Misc.parseAsJSON(context);
                        }
                        if (context === undefined) {
                            console.log(
                                'no or invalid context given for multi-register value. element"' +
                                    GetElementIdentifier(parameter.element) +
                                    '" register: "',
                                valRef.registerList,
                                '".'
                            );
                            return;
                        }

                        // re-arrange values as a map
                        var valueMap = {};
                        _.each(valRef.registerList, function (r) {
                            valueMap[r] = responseValues[deviceID][r];
                        });

                        // construct a single value from multiple registers
                        context[register] in RegisterFunctions
                            ? RegisterFunctions[context[register]](valueMap, value)
                            : window.SDE_plugins.schemaFunctions[context[register]](
                                  valueMap,
                                  valRef.registerList,
                                  value,
                                  context
                              );
                    } else {
                        value.rawValue = responseValues[deviceID][register];
                    }

                    if (uploadConfig) {
                        var infos = _.find(uploadConfig[deviceID], { type: value.type, nr: value.nr });
                    }

                    if (infos) {
                        $.extend(value, infos);
                        var result = Misc.getValueDisplayInfos(
                            responseValues[deviceID][register],
                            register,
                            infos.format,
                            infos.unit,
                            infos.display_unit,
                            infos.is_unit_fixed
                        );
                        if (result) {
                            $.extend(value, result, { has_format: true });
                        }
                    }
                    values.push(value);
                });

                var functionParameter = _.flatten([
                    parameter.element,
                    $.extend(
                        true,
                        {
                            definedParameterList: definedParameterList,
                            isLegacyFunction: isLegacyFunction,
                        },
                        self.schemaContext
                    ),
                    values,
                ]);
                return name.startsWith('toolkit')
                    ? SchemaFunctions[name.substring(8)].apply(context, functionParameter)
                    : window.SDE_plugins.schemaFunctions[name].apply(context, functionParameter);
            };
        }

        function functionIsValid(params) {
            // function list starts with a character and ends with a closing bracket?
            var checkStartAndEnd = new RegExp('^[a-zA-Z].*\\)$', 'g');
            if (!params.match(checkStartAndEnd)) {
                return false;
            }

            // brackets are matching?
            var openingBrackets = (params.match(/\(/g) || []).length;
            var closingBrackets = (params.match(/\)/g) || []).length;
            if (openingBrackets - closingBrackets != 0) {
                return false;
            }

            // all functions are separated with semicolons?
            var functionSepparator = params.match(/;/g) || 0;
            if (openingBrackets - 1 != functionSepparator) {
                return false;
            }

            return true;
        }

        var self = this;
        // parse scheme functions and extract their parameters into a map
        _.each($('svg').find('[app-func]'), function (element) {
            var functionString = element.getAttribute('app-func');
            if (functionIsValid(functionString)) {
                _.each(functionString.split(';'), function (func) {
                    var isLegacyFunction = func.indexOf('$') === -1;
                    var funcParams = func.split('(');
                    var funcName = funcParams[0].trim();
                    var parameter = { element: element, valueReferences: [] };
                    var context = {};
                    if (element.getAttribute('app-context')) {
                        context = element.getAttribute('app-context');
                    }

                    var definedParameterList = [];
                    // get the parameters for the function
                    _.each(funcParams[1].substring(0, funcParams[1].length - 1).split(','), function (param) {
                        var p = self.parseDeviceDataPoint(param);
                        definedParameterList.push(p.registerList[0] === 'undefined' ? false : true);
                        parameter.valueReferences.push(p);
                        self.addDataPointToFetchingMap(param);
                    });

                    // setup clickhandler to edit the value if possible
                    if (
                        funcName === 'toolkit_value' &&
                        element.parentNode &&
                        element.parentNode.parentNode &&
                        element.parentNode.parentNode.classList &&
                        element.parentNode.parentNode.classList.contains('SDECustom') &&
                        definedParameterList.length > 1
                    ) {
                        var editValue = {};
                        editValue.actualValue = definedParameterList[0]
                            ? parameter.valueReferences[0].registerList[0] + '@' + parameter.valueReferences[0].deviceID
                            : undefined;

                        editValue.desiredValue = definedParameterList[1]
                            ? parameter.valueReferences[1].registerList[0] + '@' + parameter.valueReferences[1].deviceID
                            : undefined;

                        $(element.parentNode.parentNode)
                            .unbind('click')
                            .click({ view: self, edit: editValue }, self.writeValue);
                    }

                    var newFunction = functionFactory(
                        funcName,
                        parameter,
                        context,
                        definedParameterList,
                        isLegacyFunction
                    );
                    if (newFunction) {
                        self.svgFuncList.push(newFunction);
                    }
                });
            }
        });

        // add registers/coils, that are only for editing
        _.each($('svg').find('[app-edit]'), function (element) {
            var editValue = element.getAttribute('app-edit') || '';
            // simple value or json?
            try {
                editValue = JSON.parse(editValue);
                if (editValue.actualValue && StringUtils.isDataPoint(editValue.actualValue)) {
                    self.addDataPointToFetchingMap(editValue.actualValue);
                }
                if (editValue.desiredValue && StringUtils.isDataPoint(editValue.desiredValue)) {
                    self.addDataPointToFetchingMap(editValue.desiredValue);
                }
            } catch (err) {
                // no json? add simple value
                if (StringUtils.isDataPoint(editValue)) {
                    self.addDataPointToFetchingMap(editValue);
                }
            }
            // -> add registers/coils
            $(element).unbind('click').click({ view: self, edit: editValue }, self.writeValue);
        });

        // remove duplicate registers/coils
        _.each(this.registerMap, function (values, key) {
            self.registerMap[key] = _.uniq(values);
        });
    },

    showActualValues: function () {
        this.isShowActualValue = true;

        this.updateSchema();
        this.initializeTimer();
    },

    showSetPointValues: function () {
        this.isShowActualValue = false;
        this.updateSchema();
        this.initializeTimer();
    },

    fetchCustomValuesAndEvaluateSchemaFunctions: function () {
        this.evaluateSchemaFunctions(true);
    },

    evaluateSchemaFunctions: function (refetchValues) {
        var self = this;
        if (this.valueMap == undefined || this.isAutoRefresh || refetchValues) {
            // add values common to all schemes
            if (this.commonValues.length > 0) {
                this.registerMap[this.model.id] = _.union(this.registerMap[this.model.id], this.commonValues);
            }

            // while waiting for the backend response, show available cached values
            var fakeFetchedValues = {};
            fakeFetchedValues[this.model.id] = this.model.get('data');
            _.each(this.valueMap, function (values, id) {
                fakeFetchedValues[id] = values;
            });

            this.applyCustomSVGFunctions(fakeFetchedValues, this.model.get('data'));

            // tell the layout view, we are now fetching values so that spinners can be displayed
            self.triggerMethod('fetching:customValues');
            this.controller.getRegisters(this.registerMap, this.nonPollingValues, function (resp) {
                self.valuesInitialized = true;
                // request failed? -> display info
                if (!$.isEmptyObject(self.registerMap) && resp.valuemap === undefined) {
                    resp.unfetched = true;
                    resp.valuemap = {};
                }
                // notify LayoutView and send it the fetched values
                self.triggerMethod('fetched:customValues', resp.valuemap[self.model.id]);
                self.applyCustomSVGFunctions(resp.valuemap, self.model.get('data'));
                Misc.setVisible('#js-loading-values-hint', !self.valuesInitialized);
                Misc.setVisible('#js-unfetched-hint', resp.unfetched);
            });
        } else {
            this.applyCustomSVGFunctions(this.valueMap, this.model.get('data'));
            Misc.setVisible('#js-loading-values-hint', false);
            Misc.setVisible('#js-unfetched-hint', false);
        }
    },

    applyCustomSVGFunctions: function (valueMap, cachedDeviceData) {
        this.valueMap = valueMap;
        _.each(
            this.svgFuncList,
            function (func) {
                func(this.valueMap, this.valueConfig, cachedDeviceData);
            },
            this
        );
    },

    addDataPointToFetchingMap: function (dataPointDescription) {
        dataPointDescription = this.cleanParameterName(dataPointDescription);
        function fetchDestination(dataPointDescription) {
            var fetchFromBackendReg = RegExp('^(MB)[RCID]');
            if (!dataPointDescription.match(fetchFromBackendReg)) {
                return 'frontend';
            }
            // 'nopoll' should only appear after the second '@'-symbol, but we are generous with users-syntax-errors
            if (dataPointDescription.indexOf('nopoll') > 0) {
                return 'dataBase';
            }
            return 'device';
        }
        var data = this.parseDeviceDataPoint(dataPointDescription);
        if (data.registerList[0] === 'undefined') {
            return;
        }
        switch (fetchDestination(dataPointDescription)) {
            case 'frontend':
                break;
            case 'dataBase':
                this.nonPollingValues[data.deviceID] = _.union(this.nonPollingValues[data.deviceID], data.registerList);
                break;
            case 'device':
                this.registerMap[data.deviceID] = _.union(this.registerMap[data.deviceID], data.registerList);
        }
    },

    parseDeviceDataPoint: function (value) {
        value = this.cleanParameterName(value);
        var register = value.split('@');
        var deviceID = parseInt(register[1]) || this.model.id;
        if (register[1] && register[1].trim() === 'parent') {
            deviceID = this.model.get('wired_to');
        }
        // registerList may be a single register, if no ':' is contained
        var registerList = register[0].trim().split(':');
        var length = parseInt(registerList[1]) || 0;
        var baseNr = parseInt(registerList[0].split('_')[1]);
        var dataType = registerList[0].split('_')[0];

        // value spans over mutliple registers? -> extract additional registers
        // e.g. MBR_10:4  => MBR_10, MBR_11, MBR_12, MBR_13
        if (length > 0) {
            for (var i = 0; i < length; i++) {
                registerList[i] = dataType + '_' + (baseNr + i);
            }
        }

        return { registerList: registerList, deviceID: deviceID };
    },

    navigate: function (e) {
        // scrolling with no deltaY? -> nothing to do
        if (e.type === 'wheel' && (!e.originalEvent || !e.originalEvent.deltaY)) {
            return;
        }
        var doNavigate = false;
        // start/end of event? -> reset values
        if (e.type === 'touchend' || e.type === 'touchstart') {
            this.viewState.distance = -1;
            this.viewState.pointerPositionX = -1;
            this.viewState.pointerPositionY = -1;
        }

        if (e.type === 'mousedown' || e.type === 'touchstart') {
            this.originalTarget = $(e.currentTarget).attr('id');
            // prevent text selection, when zoomed in
            if (this.viewState.zoom !== 1) {
                this.ui.container.addClass('noselect');
            }
        }

        if (e.type === 'mouseup' || e.type === 'touchend') {
            this.originalTarget = undefined;
        }

        if (e.type === 'touchstart') {
            this.viewState.wasMoved = false;
        }
        if (e.type === 'touchmove') {
            this.viewState.wasMoved = true;
            doNavigate = true;
        }

        // pan
        if (Event.isDrag(e) && this.viewState.zoom > 1) {
            // pan on minimap?
            if (this.originalTarget === 'js-minimap' || this.originalTarget === 'js-minimap-container') {
                var moveX = (-e.originalEvent.movementX * $('#schema-svg').width()) / $('#js-minimap').width();
                var moveY = (-e.originalEvent.movementY * $('#schema-svg').width()) / $('#js-minimap').width();

                this.scrollBy(-moveX, -moveY);
            } else {
                if (e.type === 'touchmove') {
                    if (this.viewState.pointerPositionX !== -1) {
                        this.scrollBy(
                            this.viewState.pointerPositionX - e.originalEvent.touches[0].clientX,
                            this.viewState.pointerPositionY - e.originalEvent.touches[0].clientY
                        );
                        this.updateViewBox(e.originalEvent.touches[0].clientX, e.originalEvent.touches[0].clientY);
                    }
                    this.viewState.pointerPositionX = e.originalEvent.touches[0].clientX;
                    this.viewState.pointerPositionY = e.originalEvent.touches[0].clientY;
                } else {
                    this.scrollBy(-e.originalEvent.movementX, -e.originalEvent.movementY);
                }
            }
            this.updateMinimap();
            doNavigate = true;
        }

        // scroll
        if (e.type === 'wheel' && !e.ctrlKey) {
            // no scrolling? -> do nothing
            e.preventDefault();
            var amount = e.altKey ? 500 : 100;
            amount *= Math.sign(e.originalEvent.deltaY);
            // scroll horizontally
            if (e.shiftKey) {
                this.scrollBy(amount, 0);
            } else {
                this.scrollBy(0, amount);
            }
            doNavigate = true;
        }
        if (e.type === 'wheel' && e.ctrlKey) {
            // zooming
            this.setZoom(e);
        }

        if (doNavigate) {
            this.updateViewBox();
            setTimeout($.proxy(this.updateMinimap, this), 100);
        }
    },

    scrollBy: function (x, y) {
        if (this.viewState.noScroll) {
            console.log('Scrolling is not supported by your browser. Use chrome or firefox instead.');
            return;
        }
        this.ui.container[0].scrollBy(x, y);
    },

    // sets the center of the minimap viewport.
    setCenter: function (xScrollOffset, yScrollOffset) {
        var x = xScrollOffset / this.ui.container[0].scrollWidth;
        var y = yScrollOffset / this.ui.container[0].scrollHeight;
        // todo: add half of the viewport width and height (as percentage)
        this.viewState.centerX = x + 1 / (2 * this.viewState.zoom);
        this.viewState.centerY = y + 1 / (2 * this.viewState.zoom);
    },

    setZoom: function (e, resetZoom) {
        var id = $(e.currentTarget).attr('id');
        if (resetZoom) {
            id = 'js-zoom-reset';
        }
        var zoomDelta = 0;
        switch (id) {
            case 'js-zoom-reset':
                this.viewState.zoom = 1;
                break;
            case 'js-zoom-in':
                zoomDelta = 0.25;
                break;
            case 'js-zoom-out':
                zoomDelta = -0.25;
                break;
        }

        switch (e.type) {
            case 'wheel':
                if (!e.originalEvent || !e.originalEvent.deltaY || !e.ctrlKey) {
                    return;
                }

                var sign = -Math.sign(e.originalEvent.deltaY);
                if (isNaN(sign) || typeof sign != 'number') {
                    return;
                }
                zoomDelta = e.altKey ? (sign * 5) / 4 : sign / 4;
                break;
            case 'touchstart':
            case 'touchmove':
                if (!e.originalEvent.touches || e.originalEvent.touches.length <= 1) {
                    return;
                }
                var currentDistance = Event.fingerDistance(e.originalEvent);
                // first touche with multiple fingers?
                if (this.viewState.distance === -1) {
                    this.viewState.distance = currentDistance;
                } else {
                    zoomDelta = (currentDistance - this.viewState.distance) / 400;
                }
                break;
        }
        // we only want to zoom the schema, not the whole page
        e.preventDefault();
        var oldZoom = this.viewState.zoom;
        this.viewState.zoom += zoomDelta;
        // no zooming? -> return
        if (oldZoom - this.viewState.zoom === 0 && id !== 'js-zoom-reset') {
            return;
        }

        // keep zoom in the interval [1,10];
        this.viewState.zoom = Math.min(Math.max(1, this.viewState.zoom), 10);
        if (this.viewState.zoom === 1) {
            this.viewState.centerY = 0.5;
            this.viewState.centerX = 0.5;
            this.ui.container.scrollTop(0);
            this.ui.container.scrollLeft(0);
        }

        // keep current image center while zooming
        this.updateScrollBars(this.viewState.zoom - oldZoom);
        this.updateMinimap();
        this.updateViewBox();
        // no zoom? -> allow text-selection
        if (this.viewState.zoom === 1) {
            this.ui.container.removeClass('noselect');
        }
    },

    updateScrollBars: function (zoomDelta) {
        var containerHeight = $('#schema-container').css('height');
        var overflowSetting = this.viewState.zoom == 1 ? 'unset' : 'scroll';

        this.ui.container.attr('style', 'overflow:' + overflowSetting + ';height:' + containerHeight);
        $('#schema-svg').attr(
            'style',
            'height:' + this.viewState.zoom * 100 + '%; width:' + this.viewState.zoom * 100 + '%;'
        );

        // keep current image center by scrolling
        this.scrollBy(
            this.viewState.centerX * this.viewState.width * zoomDelta,
            this.viewState.centerY * this.viewState.height * zoomDelta
        );
    },

    isClickEvent: function (e) {
        return e.type === 'click' || !this.viewState.wasMoved;
    },

    buildMinimap: function (e) {
        if (this.viewState.noScroll) {
            return;
        }
        // show minimap
        // copy schema without events and handler
        var schemaClone = $('#schema-svg').clone(false, false);
        var schemaContainer = $('#schema-container');
        this.viewState.mapMaxWidth = schemaContainer.width() / 5;
        this.viewState.mapMaxHeight = schemaContainer.height() / 5;
        function removeIDs(nodes) {
            _.each(nodes, function (node) {
                if (node.removeAttr) {
                    node.removeAttr('id');
                } else {
                    node.removeAttribute('id');
                }
                var children = node.children;
                if (typeof node.children !== 'object') {
                    var children = node.children();
                }
                if (children.length != 0) {
                    removeIDs(children);
                }
            });
        }
        removeIDs([schemaClone]);
        schemaClone.attr('id', 'js-minimap');
        schemaClone.attr('style', 'overflow:visible;');
        schemaClone.attr('preserveAspectRatio', 'xMinyMin meet');
        schemaClone.attr('width', this.viewState.mapMaxWidth);
        schemaClone.attr('height', this.viewState.mapMaxHeight);

        var viewBox = schemaClone[0].getAttribute('viewBox').split(' ');
        // the viewPort marks the visible region of the scheme
        var viewPort = document.createElement('div');
        viewPort.setAttribute('id', 'js-minimap-viewport');
        viewPort.setAttribute(
            'style',
            'width:' + this.viewState.mapMaxWidth + 'px;height:' + this.viewState.mapMaxHeight + 'px'
        );

        $('#js-minimap-container').append(schemaClone);
        $('#js-minimap-container').append(viewPort);
    },

    updateMinimap: function () {
        if (this.viewState.noScroll) {
            return;
        }
        // whole svg is visible? -> hide minimap
        if (this.viewState.zoom === 1 || window.innerWidth < 600) {
            $('#js-minimap-container').hide();
            return;
        }
        $('#js-minimap-container').show();
        // no minimap? -> create
        if ($('#js-minimap').length === 0) {
            this.buildMinimap();
        }
        var viewBox = $('#js-minimap')[0].getAttribute('viewBox').split(' ');

        // position viewPort
        var viewPort = $('#js-minimap-viewport')[0];
        var width = this.viewState.mapMaxWidth / this.viewState.zoom;
        var height = this.viewState.mapMaxHeight / this.viewState.zoom;
        var left =
            this.viewState.mapMaxWidth * this.viewState.centerX - // center of the rectangle
            width / 2; // - half the width of the rectangle
        var top =
            this.viewState.mapMaxHeight * this.viewState.centerY - // center of the rectangle
            height / 2; // - half the height of the rectangle
        viewPort.setAttribute(
            'style',
            'width:' + width + 'px;' + 'height:' + height + 'px;' + 'top:' + top + 'px;' + 'left:' + left + 'px;'
        );

        this.setCenter(this.ui.container[0].scrollLeft, this.ui.container[0].scrollTop);
    },

    cleanParameterName: function (param) {
        // trim away backend annotations (e.g. $c1 (custom) or $p1 (predefined))
        return param.replace(/\$[c,s]{1}[0-9]+/, '');
    },
});

module.exports = SchemaView;
